export const SET_TIME_INACTIVITY_WARNING = 'SET_TIME_INACTIVITY_WARNING'
export const setTimeInactivityWarning = (value: number | null) => ({ type: SET_TIME_INACTIVITY_WARNING, value })

export const SET_IS_INACTIVE = 'SET_IS_INACTIVE'
export const setTimeLastActive = (value: number) => ({ type: SET_IS_INACTIVE, value })
